import * as _ from 'lodash-es';

export default function truncate(
  text: string,
  maxLength?: number,
  separator?: string,
) {
  return _.truncate(text, { length: maxLength, omission: '…', separator });
}
